import { FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
//import { isNotEmpty, toAbsoluteUrl } from '../../../../../../../_metronic/helpers'
import { isNotEmpty } from '../../../../../../../_metronic/helpers'
import { initialDealer, Dealer } from '../core/_models'
import clsx from 'clsx'
import { useListView } from '../core/ListViewProvider'
import { ListLoading } from '../components/loading/ListLoading'
import { createDealer, updateDealer } from '../core/_requests'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { getCity, getDistrict, getDivision, getState, getWarehouse, getZone } from '../../../core/_requests'

type Props = {
  isDealerLoading: boolean
  dealer: Dealer
}

const editDealerSchema = Yup.object().shape({
  // email: Yup.string()
  //   .email('Wrong email format')
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('Email is required'),
  dealer_name: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Name is required'),
  division_id: Yup.number()
    .min(1, 'Division is required')
    .required('Division is required'),
  warehouse_id: Yup.number()
    .min(1, 'Warehouse is required')
    .required('Warehouse is required'),
  zone_id: Yup.number()
    .min(1, 'Zone is required')
    .required('Zone is required'),
  state_id: Yup.number()
    .min(1, 'State is required')
    .required('State is required'),
  city_id: Yup.number()
    .min(1, 'City is required')
    .required('City is required'),
  district_id: Yup.number()
    .min(1, 'District is required')
    .required('District is required'),
  address: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Address is required'),
  phone_number: Yup.number()
    .min(6000000000, 'Invalide Number')
    .max(9999999999, 'Invalide Number')
    .required('Mobile Number is required'),
  email: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  // tax_number: Yup.string()
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('Tax Number is required'),
  // gst_in_number: Yup.string()
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('GST Number is required'),
  // license_number: Yup.string()
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('License Number is required'),


})

const EditModalForm: FC<Props> = ({ dealer, isDealerLoading }) => {
  const { setItemIdForUpdate } = useListView()
  const { refetch } = useQueryResponse()
  const [divisions, setDivisions] = useState([])
  const [warehouses, setWarehouses] = useState([])
  const [zones, setZones] = useState([])
  const [states, setStates] = useState([])
  const [citys, setCitys] = useState([])
  const [districts, setDistricts] = useState([])
  //const [phone_numbers, setPhone_numbers] = useState([])

  const [dealerForEdit] = useState<Dealer>({
    ...dealer,
    dealer_name: dealer.dealer_name || initialDealer.dealer_name,
    division_id: dealer.division_id || initialDealer.division_id,
    warehouse_id: dealer.warehouse_id || initialDealer.warehouse_id,
    zone_id: dealer.zone_id || initialDealer.zone_id,
    state_id: dealer.state_id || initialDealer.state_id,
    city_id: dealer.city_id || initialDealer.city_id,
    district_id: dealer.district_id || initialDealer.district_id,
    address: dealer.address || initialDealer.address,
    phone_number: dealer.phone_number || initialDealer.phone_number,
    email: dealer.email || initialDealer.email,
    tax_number: dealer.tax_number || initialDealer.tax_number,
    gst_in_number: dealer.gst_in_number || initialDealer.gst_in_number,
    license_number: dealer.license_number || initialDealer.license_number,

  })

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  //const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')
  //const dealerAvatarImg = toAbsoluteUrl(`/media/${dealerForEdit.avatar}`)

  const formik = useFormik({
    initialValues: dealerForEdit,
    validationSchema: editDealerSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        if (isNotEmpty(values.id)) {
          await updateDealer(values)
        } else {
          await createDealer(values)
        }
      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
        cancel(true)
      }
    },
  })


  useEffect(() => {
    getDivision().then((result) => {
      if (result.error === false) {
        setDivisions(result.data)
      }
    })
    getWarehouse().then((result) => {
      if (result.error === false) {
        setWarehouses(result.data)
      }
    })
    getZone().then((result) => {
      if (result.error === false) {
        setZones(result.data)
      }
    })
    getState().then((result) => {
      if (result.error === false) {
        setStates(result.data)
      }
    })
  }, [])

  useEffect(() => {
    getCity(formik.values.state_id || 0).then((result) => {
      if (result.error === false) {
        setCitys(result.data)
      }
    })
    getDistrict(formik.values.state_id || 0).then((result) => {
      if (result.error === false) {
        setDistricts(result.data)
      }
    })
    //console.log(formik.values.state_id)
  }, [formik.values.state_id])

  return (
    <>
      <form id='kt_modal_add_dealer_form' className='form' onSubmit={formik.handleSubmit} noValidate>
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7'
          id='kt_modal_add_dealer_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_dealer_header'
          data-kt-scroll-wrappers='#kt_modal_add_dealer_scroll'
          data-kt-scroll-offset='300px'
        >

          <div className='row mb-3'>
            <div className='col-md-6'>
              <label className='required fw-bold fs-6 '>Name</label>
              <input
                placeholder='Name'
                {...formik.getFieldProps('dealer_name')}
                type='text'
                name='dealer_name'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.dealer_name && formik.errors.dealer_name },
                  {
                    'is-valid': formik.touched.dealer_name && !formik.errors.dealer_name,
                  }
                )}
                autoComplete='off'
                disabled={formik.isSubmitting || isDealerLoading}
              />
              {formik.touched.dealer_name && formik.errors.dealer_name && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.dealer_name}</span>
                  </div>
                </div>
              )}
            </div>

            <div className='col-md-6'>
              <label className='required fw-bold fs-6 '>Division</label>
              <select
                {...formik.getFieldProps('division_id')}
                name='division_id'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.division_id && formik.errors.division_id },
                  {
                    'is-valid': formik.touched.division_id && !formik.errors.division_id,
                  }
                )}
                disabled={formik.isSubmitting || isDealerLoading}
              >
                <option value="">-Select-</option>
                {divisions && divisions.map(({ division_name, division_id }) => (
                  <option key={division_id} value={division_id}>
                    {division_name}
                  </option>
                ))}
              </select>
              {formik.touched.division_id && formik.errors.division_id && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.division_id}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='row mb-3'>
            <div className='col-md-6'>
              <label className='required fw-bold fs-6 '>Warehouse</label>
              <select
                {...formik.getFieldProps('warehouse_id')}
                name='warehouse_id'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.warehouse_id && formik.errors.warehouse_id },
                  {
                    'is-valid': formik.touched.warehouse_id && !formik.errors.warehouse_id,
                  }
                )}
                disabled={formik.isSubmitting || isDealerLoading}
              >
                <option value="">-Select-</option>
                {warehouses && warehouses.map(({ warehouse_name, warehouse_id }) => (
                  <option key={warehouse_id} value={warehouse_id}>
                    {warehouse_name}
                  </option>
                ))}
              </select>
              {formik.touched.warehouse_id && formik.errors.warehouse_id && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.warehouse_id}</span>
                  </div>
                </div>
              )}
            </div>
            <div className='col-md-6'>
              <label className='required fw-bold fs-6 '>Zone</label>
              <select
                {...formik.getFieldProps('zone_id')}
                name='zone_id'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.zone_id && formik.errors.zone_id },
                  {
                    'is-valid': formik.touched.zone_id && !formik.errors.zone_id,
                  }
                )}
                disabled={formik.isSubmitting || isDealerLoading}
              >
                <option value="">-Select-</option>
                {zones && zones.map(({ zone_name, zone_id }) => (
                  <option key={zone_id} value={zone_id}>
                    {zone_name}
                  </option>
                ))}
              </select>
              {formik.touched.zone_id && formik.errors.zone_id && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.zone_id}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='row mb-3'>

            <div className='col-md-6'>
              <label className='required fw-bold fs-6 '>State</label>
              <select
                {...formik.getFieldProps('state_id')}
                name='state_id'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.state_id && formik.errors.state_id },
                  {
                    'is-valid': formik.touched.state_id && !formik.errors.state_id,
                  }
                )}
                disabled={formik.isSubmitting || isDealerLoading}
              >
                <option value="">-Select-</option>
                {states && states.map(({ state_name, state_id }) => (
                  <option key={state_id} value={state_id}>
                    {state_name}
                  </option>
                ))}
              </select>
              {formik.touched.state_id && formik.errors.state_id && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.state_id}</span>
                  </div>
                </div>
              )}
            </div>





            <div className='col-md-6'>
              <label className='required fw-bold fs-6 '>City</label>
              <select
                {...formik.getFieldProps('city_id')}
                name='city_id'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.city_id && formik.errors.city_id },
                  {
                    'is-valid': formik.touched.city_id && !formik.errors.city_id,
                  }
                )}
                disabled={formik.isSubmitting || isDealerLoading}
              >
                <option value="">-Select-</option>
                {citys && citys.map(({ city_name, city_id }) => (
                  <option key={city_id} value={city_id}>
                    {city_name}
                  </option>
                ))}
              </select>
              {formik.touched.city_id && formik.errors.city_id && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.city_id}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='row mb-3'>
            <div className='col-md-6'>
              <label className='required fw-bold fs-6 '>District</label>
              <select
                {...formik.getFieldProps('district_id')}
                name='district_id'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.district_id && formik.errors.district_id },
                  {
                    'is-valid': formik.touched.district_id && !formik.errors.district_id,
                  }
                )}
                disabled={formik.isSubmitting || isDealerLoading}
              >
                <option value="">-Select-</option>
                {districts && districts.map(({ district_name, district_id }) => (
                  <option key={district_id} value={district_id}>
                    {district_name}
                  </option>
                ))}
              </select>
              {formik.touched.district_id && formik.errors.district_id && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.district_id}</span>
                  </div>
                </div>
              )}
            </div>
            <div className='col-md-6 '>
              <label className='required fw-bold fs-6 '>Address</label>
              <input
                placeholder='Address'
                {...formik.getFieldProps('address')}
                type='text'
                name='address'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.address && formik.errors.address },
                  {
                    'is-valid': formik.touched.address && !formik.errors.address,
                  }
                )}
                autoComplete='off'
                disabled={formik.isSubmitting || isDealerLoading}
              />
              {formik.touched.address && formik.errors.address && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.address}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='row mb-3'>
            <div className='col-md-6'>
              <label className='required fw-bold fs-6 '>Mobile Number</label>
              <input
                placeholder='Mobile Number'
                {...formik.getFieldProps('phone_number')}
                type='text'
                name='phone_number'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.phone_number && formik.errors.phone_number },
                  {
                    'is-valid': formik.touched.phone_number && !formik.errors.phone_number,
                  }
                )}
                autoComplete='off'
                disabled={formik.isSubmitting || isDealerLoading}
              />
              {formik.touched.phone_number && formik.errors.phone_number && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.phone_number}</span>
                  </div>
                </div>
              )}
            </div>
            <div className='col-md-6'>
              <label className='required fw-bold fs-6 '>Email</label>
              <input
                placeholder='Email'
                {...formik.getFieldProps('email')}
                type='text'
                name='email'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.email && formik.errors.email },
                  {
                    'is-valid': formik.touched.email && !formik.errors.email,
                  }
                )}
                autoComplete='off'
                disabled={formik.isSubmitting || isDealerLoading}
              />
              {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.email}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='row mb-3'>
            <div className='col-md-6'>
              <label className=' fw-bold fs-6 '>Tax Number</label>
              <input
                placeholder='Tax Number'
                {...formik.getFieldProps('tax_number')}
                type='text'
                name='tax_number'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.tax_number && formik.errors.tax_number },
                  {
                    'is-valid': formik.touched.tax_number && !formik.errors.tax_number,
                  }
                )}
                autoComplete='off'
                disabled={formik.isSubmitting || isDealerLoading}
              />
              {formik.touched.tax_number && formik.errors.tax_number && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.tax_number}</span>
                  </div>
                </div>
              )}
            </div>

            <div className='col-md-6'>
              <label className=' fw-bold fs-6 '>GST Number</label>
              <input
                placeholder='GST Number'
                {...formik.getFieldProps('gst_in_number')}
                type='text'
                name='gst_in_number'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.gst_in_number && formik.errors.gst_in_number },
                  {
                    'is-valid': formik.touched.gst_in_number && !formik.errors.gst_in_number,
                  }
                )}
                autoComplete='off'
                disabled={formik.isSubmitting || isDealerLoading}
              />
              {formik.touched.gst_in_number && formik.errors.gst_in_number && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.gst_in_number}</span>
                  </div>
                </div>
              )}
            </div>

          </div>
          <div className='row mb-3'>
            <div className='col-md-6'>
              <label className=' fw-bold fs-6 '>License Number</label>
              <input
                placeholder='License Number'
                {...formik.getFieldProps('license_number')}
                type='text'
                name='license_number'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.license_number && formik.errors.license_number },
                  {
                    'is-valid': formik.touched.license_number && !formik.errors.license_number,
                  }
                )}
                autoComplete='off'
                disabled={formik.isSubmitting || isDealerLoading}
              />
              {formik.touched.license_number && formik.errors.license_number && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.license_number}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

        </div>
        {/* end::Scroll */}

        {/* begin::Actions */}
        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-dealers-modal-action='cancel'
            disabled={formik.isSubmitting || isDealerLoading}
          >
            Discard
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-dealers-modal-action='submit'
            disabled={isDealerLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>Submit</span>
            {(formik.isSubmitting || isDealerLoading) && (
              <span className='indicator-progress'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Actions */}
      </form>
      {(formik.isSubmitting || isDealerLoading) && <ListLoading />}
    </>
  )
}

export { EditModalForm }
